import request from '@/utils/request'

const freezerApi = {

  // 所有冰柜商品
  queryAllFreezerList: (params) => {
    return request({
      url: '/pocm/list',
      method: 'get',
      params
    })
  },

  // 领用冰柜列表
  queryFreezerList: (params) => {
    return request({
      url: '/quota/item/list',
      method: 'get',
      params
    })
  },

  // 查看冰柜信息
  getFreezerInfo (id) {
    return request({
      url: '/pocm/info/' + id,
      method: 'get'
    })
  },

  // 获取配额信息
  getQuotaInfo (detailId) {
    return request({
      url: '/quota/detail/info/' + detailId,
      method: 'get'
    })
  },

  // 创建领用订单
  createFreezerOrder: (data) => {
    return request({
      url: '/quota/order/create/ice-box',
      method: 'post',
      data
    })
  },

  // 导入冰柜明细
  importFreezerOrder: (data) => {
    return request({
      url: '/quota/order/ice-box/import',
      method: 'post',
      data
    })
  },

  // 验证售点编码
  checkSfaCode: (data) => {
    return request({
      url: '/client/sfa/check-code',
      method: 'post',
      data
    })
  },

  // 十条收货信息
  queryReceiving: () => {
    return request({
      url: '/quota/order/receiving-address',
      method: 'get'
    })
  }
}

export default freezerApi
